import { AddPrimitivesCommand, BasicControl, CommandGroup, CURSOR_TYPE, dymode, DYMODE_MODE, Listeners, MOUSE, Point, TnEngineContext, TnEngineExtraContext, ViewEditor } from "pytha";
import { STRUCTURE_CTRL_TYPE } from "../enums/structure-control-type";
import { Vector3 } from "three";
import { SGridPointT } from "../models/SGridPointT";
import { AddWorkPlaneAxisNetCommand } from "tnbimbase";
import { LayerType } from "@/commons/enums/layer-type";

export class AddSGridPointControl extends BasicControl {

    id = STRUCTURE_CTRL_TYPE.ADD_SGRIDPOINT;

    point_down: Point = new Point();

    capturePoint: Vector3;

    dymodePoint: Vector3 = new Vector3();

    step: number = 1;

    haveRadius: boolean = false;

    gridLayerUuid: string;

    viewObject: SGridPointT;
    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    options = {
        1: [{ name: '放弃', key: 'U' }],
        // 2: [
        //     {name: '放弃', key: 'U'},
        // ]
    }

    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);

        this.listeners.signals.needCapture.dispatch();
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        this.editor.selectControl.setEnabled(false);
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.point_down.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        this.dymodePoint.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        this.listeners.signals.sendToDymodeTip.dispatch('指定点:');
        this.extraContext.stmodeContext.setStmode('指定点', this.options[this.step] || []);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        let gridLayerUuid = this.context.layerContext.layers?.find(item => item.type === LayerType.AXIS_NET || item?.name === '轴网')?.uuid;
        if (!gridLayerUuid) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        }
        this.editor.clampControl.enabled = false
        this.gridLayerUuid = gridLayerUuid;
        console.log('AddPointControl added')
    }

    dispose(): void {
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.noNeedCapture.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.editor.clampControl.enabled = true
        console.log('AddPointControl removed')
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (event.button !== MOUSE.LEFT) return;
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_down);
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        }
        this.firstStep();
    }

    firstStep = () => {
        this.viewObject = new SGridPointT(this.point_down.clone());
        this.viewObject.color.set(this.context.layerContext.getDrawingColor());

        this.viewObject.layerUuid = this.context.layerContext.currentLayerUuid;
        this.viewObject.isGrid = true;
        this.viewObject.isGridManual = true;
        this.viewObject.layerUuid = this.gridLayerUuid;
        let entity = this.viewObject.clone();
        let maxPointT = this.editor.getEntities()?.reduce((max, item) => {
            if (item.type === 'SPointT' && item.isGrid) {
                return item?.gridNodeNumber > max ? item?.gridNodeNumber : max;
            } else {
                return max;
            }
        }, 0);
        entity.gridNodeNumber = maxPointT + 1;;
        let command = new CommandGroup();
        command.cmds.push(new AddPrimitivesCommand([entity]));
        command.cmds.push(new AddWorkPlaneAxisNetCommand([entity]));
        this.editor.history.execute(command);
        this.extraContext.stmodeContext.setStmode('指定点', this.options[this.step] || []);
    }

    _dymodeActive = false;
    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this.dymodePoint.set(value.x, value.y, value.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        } else if (value.mode === DYMODE_MODE.DIST) { }
        else if (value.mode === DYMODE_MODE.CHOOSE) {
            let choose = value.choose;
            switch (choose) {
                case 'U':
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                    break;
            }
        }
    }

    onKeyMouseConfirm = () => {
        if (this._dymodeActive) {
            this.point_down.copy(this.dymodePoint);
            this.firstStep();
            this._dymodeActive = false;
        } else {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        }
    }

}